import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-header',
  templateUrl: './single-header.component.html',
  styleUrls: ['./single-header.component.scss']
})
export class SingleHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
